import type { Branding } from "./types";

const KEY = "propsys:lastBranding";

/** Az utoljára használt szervezet arculata (a platform szintű oldalakon is ezt látja a nem szuperadmin). */
export function rememberBranding(b: Pick<Branding, "slug" | "primaryColor" | "secondaryColor" | "logoUrl" | "brandName">) {
  try {
    localStorage.setItem(KEY, JSON.stringify(b));
  } catch {
    /* privát mód */
  }
}

export function lastBranding(): Pick<Branding, "slug" | "primaryColor" | "secondaryColor" | "logoUrl" | "brandName"> | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
